import {Box, Dialog, TablePagination, Typography} from "@mui/material";
import {DataGrid, GridToolbarContainer, GridToolbarExport} from "@mui/x-data-grid";
import {useEffect, useState} from "react";
import {FaMoneyBillAlt} from "react-icons/fa";
import {HiShoppingBag} from "react-icons/hi2";
import {MdHomeWork, MdProductionQuantityLimits} from "react-icons/md";
import {RiBarcodeBoxLine} from "react-icons/ri";
import {TbSum} from "react-icons/tb";
import Stock from "./stock";
import numberFormat from "../globalFunction/prettierNumber";
import UpdateRow from "./update.item";
import gridLocale from "../ui/gridLocale";

const ViewProducts = ({
                          products,
                          currentRow,
                          updateButton = () => {
                          },
                          getRow = () => {
                          },
                      }) => {
    const [currentProducts, setCurrentProducts] = useState(products);
    const [row, setRow] = useState(currentRow);

    useEffect(() => {
        setCurrentProducts(products);
    }, [products]);

    useEffect(() => {
        setRow(currentRow);
    }, [currentRow]);

    const [dialog, setDialog] = useState({
        open: false,
        imageSrc: "",
    });
    const [dialogUpdate, setDialogUpdate] = useState({
        open: false,
        data: null,
    });

    const handleDialogClose = () => {
        setDialog({
            open: false,
            imageSrc: "",
        });
    };
    const columns = [
        {
            field: "name",
            headerName: 'Tovarlar',
            renderHeader: () => (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <HiShoppingBag fontSize={18}/>
                    <Typography>Tovarlar</Typography>
                </Box>
            ),
            width: 350,
            renderCell: (params) => {
                let imageSrc = params.row.product.photos[0].thumbnail;
                return (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: "100%",
                            backgroundColor: params.row.isChanged && "#fffbcc",
                        }}
                    >
                        <img
                            src={imageSrc}
                            alt={params.value}
                            width="50"
                            height="50"
                            style={{cursor: "zoom-in"}}
                            onClick={() => {
                                setDialog({
                                    open: true,
                                    imageSrc: params.row.product.photos[0].original,
                                });
                            }}
                        />
                        <Typography
                            variant="caption"
                            title={params.row.product.name}
                            sx={{
                                marginLeft: "1rem",
                                width: "200px",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                            }}
                        >
                            {params.row.product.name}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "vendorCode",
            headerName: 'Kodi',
            renderHeader: () =>
                (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <RiBarcodeBoxLine fontSize={18}/>
                    <Typography>Kodi</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                return (
                    <Typography variant="caption" title={params.row.product.vendorCode}>
                        {params.row.product.vendorCode}
                    </Typography>
                );
            },
        },
        {
            field: "amount",
            headerName: 'Miqdori',
            renderHeader: () =>(
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <MdProductionQuantityLimits fontSize={18}/>
                    <Typography>Miqdori</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                return (
                    <Typography variant="caption" title={params.row.amount}>
                        {params.row.amount}
                    </Typography>
                );
            },
        },
        {
            field: "price",

            headerName: 'Narxi',
            renderHeader: () =>(
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <FaMoneyBillAlt fontSize={18}/>
                    <Typography>Narxi</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                return (
                    <Typography variant="caption" title={params.value}>
                        {numberFormat(params.value)}
                    </Typography>
                );
            },
        },
        {
            field: "sum",
            headerName: 'Jami Summa',
            renderHeader: () =>(
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <TbSum fontSize={18}/>
                    <Typography>Jami Summa</Typography>
                </Box>
            ),
            width: 350,
        },
        {
            field: "remainingAmount",
            headerName: 'Qoldiq soni',
            renderHeader: () =>(
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <MdHomeWork fontSize={18}/>
                    <Typography>Qoldiq soni</Typography>
                </Box>
            ),
            width: 200,
            renderCell: (params) => {
                let vendorCode = params.row.product.id;
                return <Stock id={vendorCode}/>;
            },
        },
    ];

    return (
        <Box
            sx={{
                height: "75vh",
                width: "100%",
                backgroundColor: "background.paper",
            }}
        >
            <DataGrid
                localeText={gridLocale}
                rows={currentProducts}
                columns={columns}
                pagination
                pageSizeOptions={[25, 50, 100, 200, 500, 1000]}
                rowCount={currentProducts.length}
                onRowDoubleClick={(par, e, det) => {
                    setDialogUpdate({
                        open: true,
                        data: par.row,
                    });
                }}
                slots={{
                    footer: () => {
                        return (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    padding: "1rem",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: 1,
                                        alignItems: "center",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: "#0f9d5850",
                                            padding: "0.4rem",
                                            borderRadius: "0.5rem",
                                        }}
                                    >
                                        <Typography variant="body1" fontWeight={"bold"}>
                                            Savdo:{" "}
                                            {numberFormat(
                                                currentProducts.reduce(
                                                    (acc, item) => acc + item.price * item.amount,
                                                    0
                                                )
                                            )}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            backgroundColor: "action.hover",
                                            padding: "0.4rem",
                                            borderRadius: "0.5rem",
                                        }}
                                    >
                                        <Typography variant="body1" fontWeight={"bold"}>
                                            Skidka: {numberFormat(row.discount)}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            backgroundColor: "#0088cc30",
                                            padding: "0.4rem",
                                            borderRadius: "0.5rem",
                                        }}
                                    >
                                        <Typography variant="body1" fontWeight={"bold"}>
                                            To'lov: {numberFormat(row.amountPayment)}
                                        </Typography>
                                    </Box>
                                </Box>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 100, 200, 500, 1000]}
                                    component="div"
                                    count={currentProducts.length}
                                    rowsPerPage={25}
                                    page={0}
                                    onPageChange={() => {
                                    }}
                                    onRowsPerPageChange={() => {
                                    }}
                                    labelRowsPerPage="Soni:"
                                    labelDisplayedRows={({from, to, count}) => {
                                        return `${from}-${to} dan  ${count}`;
                                    }}
                                />
                            </Box>
                        );
                    },
                    toolbar: () => <GridToolbarContainer>
                        <GridToolbarExport csvOptions={
                            {
                                fileName: "savdo",
                                separator: ";",
                                fields: [
                                    "name",
                                    "vendorCode",
                                    "amount",
                                    "price",
                                    "sum",
                                ],
                            }
                        }/>
                    </GridToolbarContainer>

                }}
                getRowClassName={(params) => {
                    return params.row.isChanged ? "changed" : "";
                }}
            />
            <Dialog open={dialog.open} onClose={handleDialogClose}>
                <img src={dialog.imageSrc} alt="here" width="100%" height="100%"/>
            </Dialog>
            <Dialog
                open={dialogUpdate.open}
                fullWidth
                onClose={() => {
                    setDialogUpdate({
                        open: false,
                    });
                }}
            >
                <UpdateRow
                    row={dialogUpdate.data}
                    action={(json) => {
                        const products = [...currentProducts];
                        let index = products.findIndex((item) => item.id === json.id);
                        products[index] = json;
                        setCurrentProducts(products);
                        setRow({
                            ...row,
                            products: products,
                        });
                        getRow({
                            ...row,
                            products: products,
                        });
                        setDialogUpdate({
                            open: false,
                        });
                        updateButton();
                    }}
                />
            </Dialog>
        </Box>
    );
};

export default ViewProducts;
